module.exports = __webpack_public_path__ + "img/popbg.2e8310d4.png";